import { useState } from "react";

// Maps a brand name to its simpleicons.org slug + brand color.
// CDN serves single-color brand SVGs at /<slug>; we render them at full
// brand color on a neutral white tile for visual consistency.
const brandRegistry: Record<string, { slug: string; color: string }> = {
  airbnb: { slug: "airbnb", color: "FF5A5F" },
  stripe: { slug: "stripe", color: "635BFF" },
  vercel: { slug: "vercel", color: "000000" },
  notion: { slug: "notion", color: "000000" },
  github: { slug: "github", color: "181717" },
  netflix: { slug: "netflix", color: "E50914" },
  spotify: { slug: "spotify", color: "1DB954" },
  dhl: { slug: "dhl", color: "D40511" },
  paypal: { slug: "paypal", color: "003087" },
  figma: { slug: "figma", color: "F24E1E" },
  uber: { slug: "uber", color: "000000" },
  zoom: { slug: "zoom", color: "0B5CFF" },
  nike: { slug: "nike", color: "111111" },
  shopify: { slug: "shopify", color: "7AB55C" },
  grammarly: { slug: "grammarly", color: "15C39A" },
};

function normalize(brand: string): string {
  return brand.toLowerCase().replace(/[^a-z]/g, "");
}

function FallbackInitial({ brand, className }: { brand: string; className?: string }) {
  return (
    <span
      className={`flex items-center justify-center bg-slate-900 text-white ${className ?? ""}`}
      aria-hidden="true"
    >
      <span className="text-sm font-bold leading-none">{brand.charAt(0).toUpperCase()}</span>
    </span>
  );
}

export function BrandLogo({ brand, className }: { brand: string; className?: string }) {
  const [errored, setErrored] = useState(false);
  const entry = brandRegistry[normalize(brand)];

  if (!entry || errored) {
    return <FallbackInitial brand={brand} className={className} />;
  }

  return (
    <span
      className={`flex items-center justify-center overflow-hidden bg-white ring-1 ring-slate-200/70 ${className ?? ""}`}
      aria-hidden="true"
    >
      <img
        src={`https://cdn.simpleicons.org/${entry.slug}/${entry.color}`}
        alt=""
        loading="lazy"
        decoding="async"
        onError={() => setErrored(true)}
        className="h-1/2 w-1/2 object-contain"
      />
    </span>
  );
}
